import { defineComponent, useSlots, computed, createElementBlock, openBlock, normalizeClass, createElementVNode, createBlock, createCommentVNode, createVNode, mergeProps, withCtx, renderSlot, Fragment, renderList, createTextVNode, toDisplayString } from 'vue';
import { useSlotContent } from './basler-components.es362.js';
import _sfc_main$2 from './basler-components.es177.js';
/* empty css                        */
import _sfc_main$4 from './basler-components.es83.js';
/* empty css                       */
import _sfc_main$3 from './basler-components.es102.js';
/* empty css                        */
import _sfc_main$1 from './basler-components.es104.js';
/* empty css                        */

const _hoisted_1 = ["id"];
const _hoisted_2 = { class: "hero-products__outer" };
const _hoisted_3 = { class: "hero-products__inner" };
const _hoisted_4 = { class: "hero-products__media" };
const _hoisted_5 = { class: "hero-products__content" };
const _hoisted_6 = {
  key: 0,
  class: "hero-products__title"
};
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = {
  key: 1,
  class: "hero-products__title"
};
const _hoisted_9 = ["innerHTML"];
const _hoisted_10 = {
  key: 2,
  class: "hero-products__subtitle"
};
const _hoisted_11 = ["innerHTML"];
const _hoisted_12 = {
  key: 3,
  class: "hero-products__text"
};
const _hoisted_13 = {
  key: 4,
  class: "hero-products__buttons"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "HeroProductSection",
  props: {
    id: { default: "" },
    title: {},
    secondTitle: {},
    subtitle: {},
    buttons: {},
    media: {},
    textSide: { default: "left" },
    colorMode: { default: "light" },
    lazyload: { type: Boolean, default: false },
    rteText: {}
  },
  setup(__props) {
    const props = __props;
    const slots = useSlots();
    const { hasSlotContent } = useSlotContent();
    const hasRteTextSlotContent = computed(() => {
      return hasSlotContent(slots.rteText);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        id: _ctx.id,
        class: normalizeClass([
          "hero-products",
          `hero-products--text-is-${_ctx.textSide}`,
          { "theme-light": _ctx.colorMode === "light" },
          { "theme-dark": _ctx.colorMode === "dark" }
        ])
      }, [
        createElementVNode("div", _hoisted_2, [
          createElementVNode("div", _hoisted_3, [
            createElementVNode("div", _hoisted_4, [
              props.media ? (openBlock(), createBlock(_sfc_main$1, {
                key: 0,
                media: props.media,
                cols: [6, 6, 12],
                lazyload: props.lazyload
              }, null, 8, ["media", "lazyload"])) : createCommentVNode("", true)
            ]),
            createElementVNode("div", _hoisted_5, [
              props.title ? (openBlock(), createElementBlock("div", _hoisted_6, [
                createVNode(_sfc_main$2, mergeProps({ ..._ctx.title, content: void 0 }, {
                  level: _ctx.title?.level || 1,
                  "badge-size": "medium"
                }), {
                  default: withCtx(() => [
                    createElementVNode("span", {
                      innerHTML: props.title.content
                    }, null, 8, _hoisted_7)
                  ]),
                  _: 1
                }, 16, ["level"])
              ])) : createCommentVNode("", true),
              _ctx.secondTitle && _ctx.secondTitle.content ? (openBlock(), createElementBlock("div", _hoisted_8, [
                createVNode(_sfc_main$2, mergeProps({ ..._ctx.secondTitle, content: void 0 }, { "badge-size": "medium" }), {
                  default: withCtx(() => [
                    createElementVNode("div", {
                      innerHTML: _ctx.secondTitle.content
                    }, null, 8, _hoisted_9)
                  ]),
                  _: 1
                }, 16)
              ])) : createCommentVNode("", true),
              props.subtitle ? (openBlock(), createElementBlock("div", _hoisted_10, [
                createVNode(_sfc_main$2, {
                  level: props.subtitle.level || 2,
                  tag: props.subtitle.tag
                }, {
                  default: withCtx(() => [
                    createElementVNode("span", {
                      innerHTML: props.subtitle.content
                    }, null, 8, _hoisted_11)
                  ]),
                  _: 1
                }, 8, ["level", "tag"])
              ])) : createCommentVNode("", true),
              hasRteTextSlotContent.value ? (openBlock(), createElementBlock("div", _hoisted_12, [
                createVNode(_sfc_main$3, { lead: true }, {
                  default: withCtx(() => [
                    renderSlot(_ctx.$slots, "rteText")
                  ]),
                  _: 3
                })
              ])) : createCommentVNode("", true),
              props.buttons ? (openBlock(), createElementBlock("div", _hoisted_13, [
                (openBlock(true), createElementBlock(Fragment, null, renderList(props.buttons, (item, index) => {
                  return openBlock(), createBlock(_sfc_main$4, {
                    key: index,
                    link: item.link,
                    targetBlank: item.targetBlank,
                    size: item.size,
                    styleType: item.styleType,
                    iconType: item.iconType,
                    iconName: item.iconName
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(item.text), 1)
                    ]),
                    _: 2
                  }, 1032, ["link", "targetBlank", "size", "styleType", "iconType", "iconName"]);
                }), 128))
              ])) : createCommentVNode("", true)
            ])
          ])
        ])
      ], 10, _hoisted_1);
    };
  }
});

export { _sfc_main as default };
